/**
 * 是否是布尔类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
import isType from './is-type';
var isBoolean = function (value) {
    return isType(value, 'Boolean');
};
export default isBoolean;
//# sourceMappingURL=is-boolean.js.map